(function() {
  'use strict';

  angular
    .module('protein', [
    	// Generated modules
        'ngAnimate', 
    	'ngCookies',
    	'ngSanitize', 
    	'ngResource', 
    	'ngRoute', 
    	'ngMaterial',
        'ngCachedResource',
        'ui.router',
        // Dropdown lists
        'ngDropdowns',
        // Pagination
        'infinite-scroll',
        // Time and time ago
        'angularMoment',
        // Smooth scroll
        'duScroll',
        // Nice alerts
        'hSweetAlert',
        // Addthis for angular
        'sn.addthis',
        // Loading bar
        'angular-loading-bar',
        // Required for Auth0 login
        'auth0',
        'angular-jwt',
        'angular-storage',
        // Page titles & Meta data
        'viewhead',
        // Manage environments
        'ng-environments',
        // Google Analytics
        'angular-google-analytics',
        'ngFitText',
        'wu.masonry'
    ]);

})();
angular.module('protein')


	.controller('StaticPagesHomeController', function($scope, $rootScope) {

		// Meta data
		$rootScope.pageTitle = "Home";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "home";
		$rootScope.pageImage = "";

	})


	.controller('StaticPagesAboutController', function($scope, $rootScope) {

		// Meta data
		$rootScope.pageTitle = "About";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "about";
		$rootScope.pageImage = "";

	});
angular.module('protein')
  	
	.controller('PeopleController', function(Endpoint, Api, $rootScope, $scope, $q, $location, $window, $filter, $stateParams, $timeout, $mdDialog, $mdComponentRegistry, $mdSidenav) {

		$scope.page = 'people';

		// Loading
		$rootScope.loading = true;
		$scope.empty = false;
		
		// Starting values
		$rootScope.contacts = [];
		$scope.filter = {};
		$scope.sort = {};
		$scope.selectedFilters = [];
		$scope.totalItems = 0;
		$scope.totalPages = 0;
		$scope.currentPage = 1;
		$scope.nextPage = 1;
		$scope.ready = false;


		$scope.segment = $stateParams.path;
		

		// Add filters on page load
		$scope.onPageLoad = function() {
			var filters = $location.search();

			// angular.forEach(filters, function(v,k) {
			// 	switch (k) {
			// 		case "segment":
			// 			$scope.activeSegments = v;
			// 			$scope.filter.segment = v;
			// 			break;
			// 	}
			// });

			$scope.addMoreItems();

		};

		$scope.addMoreItems = function() {		
			var sort = 'first_name';
				dir = 'ASC';
				segment = $scope.segment;
				selected = $location.search();

			angular.forEach(selected, function(v,k) {
				switch(k) {
					case 'sort':
						sort = v;
						break;
					case 'direction':
						dir = v;
						break;
				}				
				
			});


			// Reset scroll
			$scope.ready = false;

			// Make API call
			if ( $scope.currentPage != $scope.totalPages && $scope.nextPage != null) {
				$scope.loadingScroll = true;

				Api(["crm","private",$rootScope.tenant,"contacts"]).query({
					segments: segment,
					page: $scope.nextPage,
					sort: sort,
					direction: dir
				}).$promise.then(function(data) {
					if(data.status != 'unauthorized') {
						angular.forEach(data.data, function(e) {
							$rootScope.contacts.push(e);
						});

						$q.all(data.data).then(function () {
							if ($rootScope.contacts.length == 0) {
								$scope.empty = true;
							}
							$scope.loadingScroll = false;
						});
						
						$scope.currentPage = $scope.nextPage;
						$scope.nextPage = data.meta.next_page;
						$scope.totalPages = data.meta.total_pages;
						$scope.totalItems = data.meta.total_count;

						// Fire scroll
						$scope.ready = true;
					
					} else {
						$scope.unauthorized = true;
						$scope.error_message = 'You are not authorized to view this page';
					}

					$rootScope.loading = false;

				});


			}

		};


		// Add filters on menu select
		$rootScope.onFilterSelect = function(e,index,term) {

			$rootScope.loading = true;

			if ($scope.filter.segment) {
				$scope.activeSectors = $scope.filter.segment;
			}


			if ($scope.sort.order) {
				switch($scope.sort.order) {
					case '10':
						$scope.activeSort = "created_at";
						$scope.activeSortDirection = "desc";
						break;
					case '11':
						$scope.activeSort = "created_at";
						$scope.activeSortDirection = "ASC";
						break;
					case '12':
						$scope.activeSort = "first_name";
						$scope.activeSortDirection = "ASC";
						break;
					case '13':
						$scope.activeSort = "first_name";
						$scope.activeSortDirection = "DESC";
						break;
					case '14':
						$scope.activeSort = "total_reach";
						$scope.activeSortDirection = "DESC";
						break;
					case '15':
						$scope.activeSort = "total_reach";
						$scope.activeSortDirection = "ASC";
						break;
				}
			}

			
			$rootScope.contacts = [];
			$scope.totalItems = 0;
			$scope.totalPages = 0;
			$scope.currentPage = 1;
			$scope.nextPage = 1;
			$scope.ready = false;

			var activeQuery = [];
			var query = [
					['sort',$scope.activeSort],
					['direction',$scope.activeSortDirection],
			];

			angular.forEach(query, function(a) {
				if(a[1] != undefined && a[1] != "" ) {
					activeQuery.push(a.join("="));
				}
			});

			$location.search(activeQuery.join("&"));
			$scope.addMoreItems();

		};
		


		$rootScope.pageTitle = 'People';
		$rootScope.pageDescription = "Collaborate with the people shaping culture";
		$rootScope.pageUrl = "/a/scouts";
		$rootScope.pageImage = "";
	})


	.controller('PeopleShowController', function(Endpoint, Api, $scope, $q, $document, $timeout, $window, $location, $rootScope, $filter, $stateParams, $state, $mdDialog, $mdComponentRegistry, $mdSidenav) {

		// Loading
		$rootScope.loading = true;
		$rootScope.view = "show";
		$scope.page = 'people';

		$rootScope.params_id = $stateParams.id;

	
		Api(["crm","private",$rootScope.tenant,"contacts", $rootScope.params_id]).get().$promise.then(function(result) {
			
			if(result.status != 'unauthorized') {
				$rootScope.entry = result;

				angular.forEach($rootScope.entry.data.attributes.contact_socials, function(s) {
					if (s.channel_id == 3) {
						$scope.instagramLink = "https://instagram.com/" + s.screen_name;
					}
					if ( s.percentage_share == null ) {
						s.percentage_share = 0;
					}
				});


			    $scope.countryFilter = function(e) {
			      var country = $filter('capitalize')($rootScope.entry.data.attributes.labels.country_list[0]);
			      return country.indexOf(e.id) !== -1;
			    }

				
				// Meta data
				$rootScope.pageTitle = $rootScope.entry.data.attributes.first_name + " " + $rootScope.entry.data.attributes.last_name;
				$rootScope.pageDescription = $rootScope.entry.data.attributes.description;
				$rootScope.pageUrl = "/a/" + $rootScope.tenantIndex + "/contact/" + $rootScope.entry.data.attributes.slug;
				$rootScope.pageImage = $rootScope.entry.data.attributes.fullname;
			
			} else {
				$scope.unauthorized = true;
				$scope.error_message = 'You are not authorized to view this page';
				
				// Meta data
				$rootScope.pageTitle = 'Unauthorized';
				$rootScope.pageDescription = $scope.error_message;
			}

			$rootScope.loading = false;

			$scope.addMoreImages();
			$scope.addMoreresponses();
			
		});

		
		/////////////////////////////////////
		////////// Contacts Images //////////
		/////////////////////////////////////
		
		$scope.images = [];
		$scope.imagesTotalItems = 0;
		$scope.imagesTotalPages = 0;
		$scope.imagesCurrentPage = 1;
		$scope.imagesNextPage = 1;
		$scope.ready = false;
		$rootScope.imagesLoading = true;
		$scope.imagesReady = false;

		$scope.addMoreImages = function() {

			// Reset scroll
			$scope.imagesReady = false;

			// Make API call
			if ( $scope.imagesCurrentPage != $scope.imagesTotalPages && $scope.imagesNextPage != null) {

				$scope.loadingScroll = true;
				Api(["crm", "private",$rootScope.tenant, "contacts", $rootScope.params_id, "contact_images"]).query({
					page: $scope.imagesNextPage
				}).$promise.then(function (result) {
					if(result.status != 'unauthorized') {

						angular.forEach(result.data, function (e) {
							$scope.images.push(e);
						});

						$q.all(result.data).then(function () {
							if ($scope.images.length == 0) {
								$scope.imagesEmpty = true;
							}
							$rootScope.imagesLoading = false;
						});

						$scope.imagesCurrentPage = $scope.imagesNextPage;
						$scope.imagesNextPage = result.meta.next_page;
						$scope.imagesTotalPages = result.meta.total_pages;
						$scope.imagesTotalItems = result.meta.total_count;

						// Fire scroll
						$scope.imagesReady = true;
					}

				});
			}

		};


		/////////////////////////////////////
		////////// Contacts Responses ///////
		/////////////////////////////////////
		
		$scope.responses = [];
		$scope.responsesTotalItems = 0;
		$scope.responsesTotalPages = 0;
		$scope.responsesCurrentPage = 1;
		$scope.responsesNextPage = 1;
		$scope.ready = false;
		$rootScope.imagesLoading = true;
		$scope.responsesReady = false;
		$scope.empty = false;

		$scope.addMoreresponses = function() {

			// Reset scroll
			$scope.responsesReady = false;

			// Make API call
			if ( $scope.responsesCurrentPage != $scope.responsesTotalPages && $scope.responsesNextPage != null) {

				$scope.loadingScroll = true;

				Api(["publish","private",$rootScope.tenant,"pages","stream"]).query({
					contact: $rootScope.params_id,
					page: $scope.responsesNextPage
				}).$promise.then(function (result) {
					if(result.status != 'unauthorized') {

						angular.forEach(result.data, function (e) {
							$scope.responses.push(e);
						});

						$q.all(result.data).then(function () {
							if ($scope.responses.length == 0) {
								$scope.empty = true;
							}
							$rootScope.imagesLoading = false;
						});

						$scope.responsesCurrentPage = $scope.responsesNextPage;
						$scope.responsesNextPage = result.meta.next_page;
						$scope.responsesTotalPages = result.meta.total_pages;
						$scope.responsesTotalItems = result.meta.total_count;

						// Fire scroll
						$scope.responsesReady = true;
					}

				});

			}

		};




	});

angular.module('protein')
  	
	.controller('NewslettersController', function(ApiCms, $document, $scope, $rootScope, $stateParams, $filter, $timeout) {

		$scope.page = 'newsletters';
		$scope.loading = true;

		$scope.entries = [];
		
		ApiCms('entries').query({
            status: 'open',
            type: 'newsletter'
        }).$promise.then(function (data) {
            angular.forEach(data["items"], function (e) {
                $scope.entries.push(e);
            });
            $scope.loading = false;
        });


		$rootScope.pageTitle = "Newsletters";
		$rootScope.pageUrl = "/a/newsletter";
		$rootScope.pageImage = "";

	})


	.controller('NewslettersShowController', function(ApiCms, $scope, $rootScope, $stateParams) {

		$scope.page = 'newsletters';
		$scope.loading = true;

		ApiCms('entries').get({
            id: $stateParams.id
        }).$promise.then(function (data) {
            $scope.entry = data;
            
            $scope.loading = false;
			console.log($scope.entry);
			$rootScope.pageTitle = $scope.entry.title;
			$rootScope.pageUrl = "/a/newsletters/" + $scope.entry.id;
			$rootScope.pageImage = "";
        });





	});

angular.module('protein')

	.controller('LoginController', function (auth, $rootScope, $scope, $location, $filter, store, Api, $cookies, $window, $cachedResource) {

		// Auth0 login
		$scope.username = '';
        $scope.pass = '';
        $scope.message = 'Sign in';

        function onLoginSuccess(profile, token) {
            
            $scope.message = 'Sign in';

            var month = new Date(+new Date + 2.592e+9);
            var year = new Date(+new Date + 3.154e+10);
            var uuid = profile.user_id.split("|")[1];

            $cookies.put('ProteinOsToken', token, { expires: month, domain: $rootScope.environment.domain});
            $cookies.put('ProteinOsUuid', uuid, { expires: year, domain: $rootScope.environment.domain});
            
            store.set('token', token);

            // Fetch the user and find which teams they belong to
            Api(["access", "private", "authorizes"]).save().$promise.then(function(data) {


                // If callback is a success login and redirect
                var role_id = data.data.attributes.role_id;
                var currentUserTeams = [];
                angular.forEach(data.data.attributes.accounts, function (t) {
                    currentUserTeams.push(t.slug);
                });

                if (role_id != 5 && currentUserTeams.indexOf("yeezy") != -1 ) {
                    $rootScope.loggedIn = true;
                    store.set('protein-profile', data);
                    $window.location.href = '/a/moodboard';

                } else {
                    $rootScope.loggedIn = false;
                    auth.signout();
                    localStorage.removeItem('protein-profile');
                    localStorage.removeItem('token');
                    $cookies.remove('ProteinOsToken', {domain: $rootScope.environment.domain});
                    $cookies.remove('ProteinOsUuid', {domain: $rootScope.environment.domain});
                    $cachedResource.clearCache();
                    $window.location.href = '/login';
                    $scope.fail_message = "You don't have permission to access this page";
                }

            
            });
        }


        function onLoginFailed() {
            $scope.fail_message = "Your password and username don't match";
            $scope.message = 'Sign in';
        }

        $scope.submit = function () {
         	$scope.message = 'Loading...';
         	auth.signin({
             	connection: 'Username-Password-Authentication',
             	username: $filter('lowercase')($scope.username),
             	password: $scope.pass,
             	authParams: {
                 	scope: 'openid name email'
             	}
         	}, onLoginSuccess, onLoginFailed);
     	};

        $rootScope.pageTitle = "Login";
        $rootScope.pageDescription = "Collaborate with the people shaping culture";
        $rootScope.pageUrl = "login";
        $rootScope.pageImage = "";
	})

	.controller('LogoutController', function (auth, $rootScope, $scope, $window, $cachedResource, $cookies) {

        $rootScope.adminPage = false;

        localStorage.removeItem('protein-profile');
        localStorage.removeItem('token');
        $cookies.remove('ProteinOsToken', {domain: $rootScope.environment.domain});
        $cookies.remove('ProteinOsUuid', {domain: $rootScope.environment.domain});
        $cookies.remove('ProteinOsArticleAccess', {domain: $rootScope.environment.domain});
        $cookies.remove('ProteinOsCollectionAccess', {domain: $rootScope.environment.domain});

        auth.signout();
        $scope.$parent.message = '';
        $cachedResource.clearCache();
        $window.location.href = '/';

	})

    .controller('LoginResetController', function (auth, $scope, $rootScope, Api, sweet, $location) {

        $scope.user = {
            email: ''
        };
        $scope.message = 'Reset';

        $scope.submit = function() {
            $scope.message = 'Loading...';
            Api(['access', 'public', 'users', 'password_reset']).save({
                email: $scope.user.email
            }).$promise.then(function() {
                swal("Success", "You should receive and email with password reset instructions shortly", "success");
                $location.path( "/" );
            });
        
        };

        $rootScope.pageTitle = "Reset Password";
        $rootScope.pageDescription = "We follow the people and ideas shaping our world";
        $rootScope.pageUrl = "reset";
        $rootScope.pageImage = "";

    })

    ;

angular.module('protein')
  	
	.controller('EntriesController', function($scope, $rootScope, Api, $window, $location, $q, $mdDialog) {

		$scope.page = 'moodboard';

		// Loading
		$rootScope.loading = true;
		$scope.empty = false;

		// Starting values
		$scope.responses = [];
		$scope.filter = {};
		$scope.sort = {};
		$scope.activeFilters = [];

		$scope.activeTypes = [];
		$scope.totalItems = 0;
		$scope.totalPages = 0;
		$scope.currentPage = 1;
		$scope.nextPage = 1;
		$scope.ready = false;

		$scope.onPageLoad = function() {
			var filters = $location.search();

			angular.forEach(filters, function(v,k) {
				switch (k) {
					case "type":
						$scope.activeTypes = v;
						$scope.filter.type = v;
						break;
				}

			});

			$scope.addMoreItems();
		};

		$scope.addMoreItems = function() {

			var sort = '';
			dir = '';
			type = '';
			filters = $location.search();

			angular.forEach(filters, function(v,k) {
				switch(k) {
					case 'sort':
						sort = v;
						break;
					case 'direction':
						dir = v;
						break;
					case 'type':
						type = v;
						break;
				}
			});

			// Reset scroll
			$scope.ready = false;

			if ( $scope.currentPage != $scope.totalPages && $scope.nextPage != null) {

				$scope.loadingScroll = true;

				Api(["publish","private",$rootScope.tenant,"pages","stream"]).query({
					type: type,
					page: $scope.nextPage,
					promoted: true,
					sort: sort,
					direction: dir
				}).$promise.then(function(data) {
					if(data.status != 'unauthorized') {
						angular.forEach(data.data, function(e) {
							$scope.responses.push(e);
						});
						$q.all(data.data).then(function () {
							if ($scope.responses.length == 0) {
								$scope.empty = true;
							}
							$scope.loadingScroll = false;
							$rootScope.imagesLoading = false;
						});

						$scope.currentPage = $scope.nextPage;
						$scope.nextPage = data.meta.next_page;
						$scope.totalPages = data.meta.total_pages;
						$scope.totalItems = data.meta.total_count;

						// Fire scroll
						$scope.ready = true;

					} else {
						$scope.unauthorized = true;
						$scope.error_message = 'You are not authorized to view this page';
					}

					$rootScope.loading = false;


				});
			}

		};

		/////////////////////////////////////////////
		////////////////// Filters //////////////////
		/////////////////////////////////////////////

		// Add filters on menu select
		$rootScope.onFilterSelect = function(e) {
			switch(e) {
				// Sorting
				case 0:
					switch($scope.sort.order) {
						case '10':
							$scope.activeSort = "created_at";
							$scope.activeSortDirection = "DESC";
							break;
						case '11':
							$scope.activeSort = "created_at";
							$scope.activeSortDirection = "ASC";
							break;
					}
					break;
				case 1:
					$scope.activeTypes = $scope.filter.type;
					break;
			}


			// Reset all select list values
			$scope.responses = [];

			$scope.totalItems = 0;
			$scope.totalPages = 0;
			$scope.currentPage = 1;
			$scope.nextPage = 1;
			$scope.ready = false;

			var activeQuery = [];
			var query = [
				['sort',$scope.activeSort],
				['direction',$scope.activeSortDirection],
				['type',$scope.activeTypes]
			];

			angular.forEach(query, function(a) {
				if(a[1] != undefined && a[1] != "" ) {
					activeQuery.push(a.join("="));
				}
			});

			$location.search(activeQuery.join("&"));
			$scope.addMoreItems();

		};


		// $scope.randomClass = function () {
		// 	return Math.round( Math.random() * (4 - 1) );
		// };


		$rootScope.pageTitle = "Welcome";
		$rootScope.pageUrl = "/a/moodboard"
		$rootScope.pageDescription = 'Collaborate with the people shaping culture';
		$rootScope.pageImage = "";

	})


	.controller('EntriesShowController', function(Api, $scope, $rootScope, $stateParams) {


		// Loading
		$scope.page = "moodboard";
		$rootScope.loading = true;
		$rootScope.imagesLoading = true;

		Api(["connect","private",$rootScope.tenant,"tasks",$stateParams.id,'contact_tasks',$stateParams.contact_task_id,'contact_task_responses']).query({
			sort: "created_at",
			direction: "desc",
			contact_id: $stateParams.contact_id
		}).$promise.then(function(result) {
			$scope.responses = result.data;
			$scope.task = $scope.responses[0].attributes;
			if ($scope.responses.length == 0) {
				$scope.empty = true;
			}
			$scope.loading = false;
			$rootScope.imagesLoading = false;

			$rootScope.pageTitle = $scope.task.task.title;
			$rootScope.pageDescription = "Collaborate with the people shaping culture";
			$rootScope.pageUrl = "/a/moodboard";
			$rootScope.pageImage = "";
		});






	});

angular.module('protein')
  	
	.controller('AppController', function($scope, $rootScope, $document, $window, $timeout, $location, $cookies, $http, auth, store, $stateParams, $state, $mdSidenav, $mdDialog, $environment) {
		
		$rootScope.environment = $environment;

		// Current year
		$scope.date = moment().format();

	    // Scroll to top on page load
		$rootScope.$on('$locationChangeStart', function(event, newState, oldUrl){
			$document.scrollTopAnimated(0, 100);
			// $rootScope.currentPage = toState.name.split(".")[1];
		});


		// Header nav dropdown submenu
	  	var originatorEv;

	    $scope.openMenu = function($mdOpenMenu, ev) {
	    	originatorEv = ev;
	   		$mdOpenMenu(ev);
	    };
		
	    $scope.closeMenu = function($mdCloseMenu, ev) {
	    	originatorEv = ev;
	   		$mdCloseMenu(ev);
	    };

	    // Navigation side menu
	    $scope.toggleLeft = buildToggler('left');
		
		function buildToggler(navID) {
			return function() {
				$mdSidenav(navID)
					.toggle()
					.then(function () {
				});
			}
		}

		$scope.close = function () {
			$mdSidenav('left').close();
		};

	    


	});

angular.module('protein')


	.controller('AdminController', function(CurrentUserInfo,Api,$scope,$rootScope,$window,$mdDialog,$filter) {

		$rootScope.adminPage = true;
		$rootScope.loggedIn = true;

		$rootScope.userInfo = $rootScope.user.data.attributes;

		$scope.currentDate = new Date();
		$scope.currentTime = $filter('date')($scope.currentDate, 'H');	

		$rootScope.tenant = 'yeezy';

		$rootScope.cms_endpoint = "https://cms.prote.in/yeezy/api/v2/";


		$scope.closeModal = function() {
			$mdDialog.hide();
	    };


		$scope.imageModal = function($event, s) {
			$mdDialog.show({
				clickOutsideToClose: true,
				templateUrl: 'templates/views/entries/shared/entry-modal.html',
				scope: $scope,
				preserveScope: true,
				targetEvent: $event,
				locals: { s: s },
				controller: ['$scope', 's', function($scope, s) {
					$scope.s = s;
					console.log(s);
				}]
			});
		};

		

		$scope.loadjscssfile = function(filename, filetype) {
		    if (filetype == "js") {
		        // if filename is a external JavaScript file
		        var fileref = document.createElement('script');
		        fileref.setAttribute("type","text/javascript");
		        fileref.setAttribute("src", filename);
		    }
		    else if (filetype == "css") {
		        //if filename is an external CSS file
		        var fileref = document.createElement("link");
		        fileref.setAttribute("rel", "stylesheet");
		        fileref.setAttribute("type", "text/css")
		        fileref.setAttribute("href", filename)
		    }
		    if (typeof fileref != "undefined") {
		        document.getElementsByTagName("head")[0].appendChild(fileref)
		    }
		};

	})


	.controller('AdminProfileController', function($scope, $rootScope, Api, Upload, store, $mdToast) {

		$rootScope.page = "profile";
		$scope.segment = "profile";

		$scope.uploadFiles = function(file, errFiles) {
	        $scope.f = file;
	        $scope.imageWarning = false;
	        if (file) {
				$scope.imageToSend = Upload.base64DataUrl(file);
				$scope.userInfo.image.medium = file.$ngfBlobUrl;
	        }
	        if ( errFiles ) {
	        	if ( errFiles.length ) {
	        		$scope.imageWarning = true;
	        		if ( errFiles[0].$error == 'maxSize' ) {
	        			$scope.imageWarningMessage = "Sorry, this image is too large. Can you try another?"
	        		}
					if ( errFiles[0].$error == 'maxHeight' ) {
						$scope.imageWarningMessage = "Sorry, this image is too tall. Can you try another?"
					}
	        	}
	        }
	    };


		// Update user account info
		$scope.userDetailsForm = function() {

			if ( $scope.imageToSend == undefined ) {
				var obj = {
					first_name: $scope.userInfo.first_name,
					last_name: $scope.userInfo.last_name,
					email: $scope.userInfo.email
				}
			} else {
				var obj = {
					first_name: $scope.userInfo.first_name,
					last_name: $scope.userInfo.last_name,
					image: $scope.imageToSend.$$state["value"],
					email: $scope.userInfo.email
				}
			}

			$scope.loading = true;

			Api([$rootScope.userInfo.accounts[0].slug, 'access', 'private', 'users', $rootScope.uuid]).update({
				user: obj
			}).$promise.then(function (result) {
				$scope.loading = false;
				localStorage.removeItem('protein-profile');
				store.set('protein-profile', result);
				$mdToast.show(
					$mdToast.simple()
						.content('Details updated')
						.position('bottom right')
						.hideDelay(3000)
						.parent('body')
				);
			});
		};

		$rootScope.pageTitle = "Your profile";       
        $rootScope.pageDescription = 'Collaborate with the people shaping culture';
        $rootScope.pageImage = '';


	})

	

;






(function() {
  'use strict';

  angular
    .module('protein')
    .constant('Endpoint', "https://api.getradar.io/v1/")
    .constant('EndpointCMS', "https://cms.prote.in/v4/")

    ;
    
})();

(function() {
  'use strict';

  angular
    .module('protein')
    
    // The CMS API 
    .factory('Api', function(Endpoint, $resource) {
        return function(key) {
            key = key.join? key.join('/'):key;
            return $resource(Endpoint + key + '/:id.json', {id: "@id"}, {
                'update': { method: 'PUT' },
                'query':  { method:'GET', cache: false, isArray: false },
                'array':  { method:'GET', cache: false, isArray: true }
            });
        };
    })

    .factory('ApiCms', function($rootScope, $resource) {     
        return function(key) {
            key = key.join? key.join('/'):key;
            return $resource($rootScope.cms_endpoint + key + '/:id' + '/:section' + '/:sub_section' + '/:extra.json', {id: "@id", section: "@section", sub_section: "@sub_section", extra: "@extra"}, {
                'update': { method: 'PUT'},
                'query':  { method:'GET', cache: false, isArray: false },
                'array':  { method:'GET', cache: false, isArray: true }
            });
        };
    })

    // Get current logged in user
    .service('CurrentUserInfo', function(store, $rootScope){
        $rootScope.user = store.get('protein-profile');
        $rootScope.uuid = $rootScope.user.data.id;
        $rootScope.role = $rootScope.user.data.attributes.role_name;
        $rootScope.roleId = $rootScope.user.data.attributes.role_id;
    })

    .service('CurrentTenant', function(CurrentUserInfo,$stateParams,$rootScope){
        $rootScope.tenant = 'yeezy';
    })

    .service('CurrentRole', function(CurrentUserInfo,$rootScope, Api){
        Api([$rootScope.tenant.slug, "access","private","users",$rootScope.uuid]).get().$promise.then(function(results) {
            $rootScope.role = results.data.attributes.role_name;
            $rootScope.roleId = results.data.attributes.role_id;
        });
    })


    // Trusted hosts [ie, a url from youtube, vimeo hosted files etc]
    .filter('trustUrl', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    })

    // Trust embed 
    .filter('trustEmbed', function ($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    })

    // Capitalise text
    .filter('capitalize', function() {
        return function(input, all) {
            return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}) : '';
         };
    })

    // Replace hyphens with amp
    .filter('tidy', function() {
        return function(str) {
            return str.replace("-", " & ");
        };
    })

    // Pluralize
    .filter('pluralize', function() {
        return function(str) {
            if (str.substr(str.length - 1) == "s") {
                return str.slice(0, -1);
            }
            else {
                return str;
            }
        };
    })


    // Replace hyphens with space
    .filter('space', function() {
        return function(str) {
            return str.replace(/-/g, ' ');
        };
    })

    // Replace hyphens with space
    .filter('parameterize', function() {
        return function(str) {
            return str.replace(" ", "-").replace("&", "-");
        };
    })

    // Add or remove @ symbol
    .filter('handle', function() {
        return function(str) {
            if(str.charAt(0) == "@") {
                return str
            }
            else {
                var newStr = "@";
                newStr += str;
                return newStr;
            }

        };
    })

    .filter('removeHandle', function() {
        return function(str) {
            if(str.charAt(0) == "@") {
                return str.substring(1);
            }
            else {
                return str
            }

        };
    })

    // Add http
    .filter('http', function() {
        return function(str) {           
            if(str.substring(0,4) == "http") {
                return str
            }
            else {
                var newStr = "http://";
                newStr += str;
                return newStr;
            }
        };
    })

    // Add https
    .filter('https', function() {
        return function(str) {           
            if(str.substring(0,7) == "http://") {
                var str = str.substring(7);
                var newStr = "https://";
                newStr += str;
                return newStr;
            }
            else {
                return str
            }
        };
    })

    // Chop text string if longer than defined length
    .filter('strLimit', ['$filter', function($filter) {
        return function(input, limit) {
            if (! input) return;
            if (input.length <= limit) {
                return input;
            }
            return $filter('limitTo')(input, limit) + '...';
        };

    }])

    .filter('percentage', ['$filter', function ($filter) {
        return function (input, decimals) {
            return $filter('number')(input * 100, decimals) + '%';
        };
    }])

    
    // Use on daily digest to clean up url source
    .filter('domain', [ function () {
        return function (input) {
            var elements = angular.element('<a href="'+input+'"/>');
            var d = elements[0].hostname;
            if(d.indexOf("www.") > -1) {
                var domain = d.replace("www.","");
            }
            else {
                var domain = d;
            }
            return domain;
        };
    }])

    // Strip quote marks from pull quotes
    .filter('removeQuoteMarks', [ function () {
      return function(str) {
          return str.replace('"', "").replace('"', "").replace('“', "");
      };
    }])

    
    // Strip URL from iframe
    .filter("stripUrl", function() {
        return function(str) {
            var re = /\ssrc=(?:(?:'([^']*)')|(?:"([^"]*)")|([^\s]*))/i,
                res = str.match(re),
                src = res[1]||res[2]||res[3];
            return src;
        };
     })


    .filter('socialHandle', function() {
        return function(id) {
            if(id == 2) {
               return "https://facebook.com"
            } else if (id == 3) {
                return "https://instagram.com"
            } else if (id == 4) {
                return "https://twitter.com"
            } else if (id == 5) {
                return "https://pinterest.com"
            } else if (id == 8) {
                return "https://linkedin.com/in"
            } else if (id == 9) {
                return "https://youtube.com/user"
            } else if (id == 10) {
                return "https://vimeo.com"
            }

        };
    })


      .filter('thousandSuffix', function () {
          return function (input, decimals) {
              var exp, rounded,
                  suffixes = ['k', 'M', 'G', 'T', 'P', 'E'];

              if (window.isNaN(input)) {
                  return null;
              }

              if (input < 1000) {
                  return input.split(".")[0];
              }

              exp = Math.floor(Math.log(input) / Math.log(1000));

              return (input / Math.pow(1000, exp)).toFixed(decimals) + suffixes[exp - 1];
          };
      })


      .filter('unique', function () {

          return function (items, filterOn) {

              if (filterOn === false) {
                  return items;
              }

              if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                  var hashCheck = {}, newItems = [];

                  var extractValueToCompare = function (item) {
                      if (angular.isObject(item) && angular.isString(filterOn)) {
                          return item[filterOn];
                      } else {
                          return item;
                      }
                  };

                  angular.forEach(items, function (item) {
                      var valueToCheck, isDuplicate = false;

                      for (var i = 0; i < newItems.length; i++) {
                          if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                              isDuplicate = true;
                              break;
                          }
                      }
                      if (!isDuplicate) {
                          newItems.push(item);
                      }

                  });
                  items = newItems;
              }
              return items;
          }
      })
    

      .filter('megaNumber', function () {
        
        return function (number, fractionSize) {

            if(number === null) return null;
            if(number === 0) return "0";

            if(!fractionSize || fractionSize < 0)
                fractionSize = 1;

            var abs = Math.abs(number);
            var rounder = Math.pow(10,fractionSize);
            var isNegative = number < 0;
            var key = '';
            var powers = [
                {key: "Q", value: Math.pow(10,15)},
                {key: "T", value: Math.pow(10,12)},
                {key: "B", value: Math.pow(10,9)},
                {key: "M", value: Math.pow(10,6)},
                {key: "K", value: 1000}
            ];

            for(var i = 0; i < powers.length; i++) {

                var reduced = abs / powers[i].value;

                reduced = Math.round(reduced * rounder) / rounder;

                // If large number then don't show the decimals
                if ( reduced.toString().length > 3 ) {
                  var reduced = Math.round(reduced);
                } 
                
                if(reduced >= 1){
                    abs = reduced;
                    key = powers[i].key;
                    break;
                }
            }

            return (isNegative ? '-' : '') + abs + key;
        };

    })
    
    // Get current logged in user
    .service('CurrentUser', function(store){
        return store.get('profile');
    })


    ;

})();



(function() {
  'use strict';

  angular
    .module('protein')
    .config(routeConfig)
    
  .config(['authProvider', '$sceDelegateProvider', '$routeProvider', '$httpProvider', 'jwtInterceptorProvider', '$environmentProvider', 'AnalyticsProvider', function (authProvider, $sceDelegateProvider, $routeProvider, $httpProvider, jwtInterceptorProvider, $environmentProvider, AnalyticsProvider) {
      
      $httpProvider.defaults.headers.common = {
          'Application': 'radar'
      };

      // Auth0 details
      authProvider.init({
          domain: 'protein.eu.auth0.com',
          clientID: 'O07Kwj5rVTbonnICYh2514ci1PaGZHSZ',
          loginState: 'login'
      });

      jwtInterceptorProvider.tokenGetter = ['store', function (store) {
          return store.get('token');
      }];

      // Push interceptor function to $httpProvider's interceptors
      $httpProvider.interceptors.push('jwtInterceptor');
        
      // Trust these urls
      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        '*://www.youtube.com/**',
        '*://player.vimeo.com/**',
        '*://www.vimeo.com/**',
        '*://www.shopify.com/**',
        '*://eventbrite.com',
        '*://google.com',
        '*://twitter.com',
        '*://t.co',
        '*://instagram.com',
        '*://campaign.prote.in/••'
      ]);

      $environmentProvider.environments = [
        {
            name: 'local',
            pattern: /localhost/,
            url: 'http://localhost:3000/',
            domain: 'localhost'
        },
        {
            name: 'dev',
            pattern: /dist/,
            url: 'http://dist.dev/',
            domain: 'dev'
        },
        {
            name: 'production',
            pattern: /yeezy/,
            url: 'https://yeezy.prote.in/',
            domain: 'prote.in'
        }
      ];

      // Google Analytics tracking
      AnalyticsProvider.setAccount('UA-62774407-7');


  }])

  // Smooth scrolling
  .value("duScrollDuration", 1200)
  .value("duScrollOffset", 80)
  .value('THROTTLE_MILLISECONDS', 500)

	.run(function ($rootScope, auth, store, jwtHelper, $location) {
  		// This hooks al auth events to check everything as soon as the app starts
		auth.hookEvents();

  		// This events gets triggered on refresh or URL change
		$rootScope.$on('$locationChangeStart', function() {
    		var token = store.get('token');
	    	if (token) {
	      		if (!jwtHelper.isTokenExpired(token)) {
	        		if (!auth.isAuthenticated) {
	          			auth.authenticate(store.get('profile'), token);
	        		}
	      		} else {
	        		// Either show the login page or use the refresh token to get a new idToken
	        		$location.path('/logout');
              store.remove('token');
	      		}
			  }
		})

 	});

  function routeConfig($stateProvider, $locationProvider, $urlRouterProvider) {

    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');

    
    // Routes for the site
    $stateProvider


      // .state('home', {
      //   url: '/',
      //   templateUrl: 'templates/views/static_pages/home.html',
      //   controller: 'StaticPagesHomeController'
      // })


      // Authentication
      .state('login', {
          url: '/',
          templateUrl: 'templates/views/static_pages/login.html',
          controller: 'LoginController',
          params: {
              redirect: {
                  name: '/',
                  params: {}
              }
          }
      })

      .state('logout', {
          url: '/logout',
          controller: 'LogoutController'
      })

      .state('reset', {
          url: '/reset',
          templateUrl: 'templates/views/static_pages/reset.html',
          controller: 'LoginResetController'
      })

      // Admin
      .state('admin', {
          url: '/a',
          abstract: true,
          templateUrl: 'templates/views/admin/index.html',
          data : {
              requiresLogin: false
          },
          controller: 'AdminController'
      })


      // Responses
      .state('admin.entries', {
        url: '/moodboard',
        templateUrl: 'templates/views/entries/index.html',
        controller: 'EntriesController'
      })

      .state('admin.entry', {
        url: '/moodboard/:id/:contact_task_id',
        templateUrl: 'templates/views/entries/show.html',
        controller: 'EntriesShowController'
      })
 
       // Reports
      .state('admin.newsletters', {
        url: '/newsletters',
        templateUrl: 'templates/views/newsletters/index.html',
        controller: 'NewslettersController'
      })

      .state('admin.newsletter', {
        url: '/newsletters/:id',
        templateUrl: 'templates/views/newsletters/show.html',
        controller: 'NewslettersShowController'
      })

      // People
      .state('admin.peoples', {
        url: '/{path:scout|consumers}',
        templateUrl: 'templates/views/people/index.html',
        controller: 'PeopleController'
      })

      .state('admin.people', {
        url: '/contact/:id',
        templateUrl: 'templates/views/people/show.html',
        controller: 'PeopleShowController'
      })

      // Static Pages
      .state('admin.about', {
        url: '/about',
        templateUrl: 'templates/views/static_pages/about.html',
        controller: 'StaticPagesAboutController'
      })


      ;
  }



})();

(function() {
  'use strict';

  angular
    .module('protein')

    .directive('mdHeader', function header() {
        var header = {
        	restrict: 'E',
          	templateUrl: 'templates/views/shared/header.html'
        };
        return header;
    })

    .directive('mdFooter', function footer() {
        var footer = {
          	restrict: 'E',
          	templateUrl: 'templates/views/shared/footer.html'
        };
        return footer;
    })

    .directive('mainNavigation', function mainNavigation() {
        var mainNavigation = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/navigation.html'
        };
        return mainNavigation;
    })

    .directive('loading', function loading() {
       var loading = {
           restrict: 'E',
           templateUrl: 'templates/views/shared/loading.html'
       };
       return loading;
    })

    .directive('loadingAnimation', function loadingAnimation() {
       var loadingAnimation = {
           restrict: 'E',
           templateUrl: 'templates/views/shared/loading-animation.html'
       };
       return loadingAnimation;
    })

    .directive('empty', function empty() {
       var empty = {
           restrict: 'E',
           templateUrl: 'templates/views/shared/empty.html'
       };
       return empty;
    })

    .directive('entryCard', function entryCard() {
       var entryCard = {
           restrict: 'E',
           templateUrl: 'templates/views/entries/shared/entry-card.html'
       };
       return entryCard;
    })

    // Smooth transition between pages
    .directive('smoothLoad', function ($window, $rootScope, $timeout) {
        return function() {

            $rootScope.$on('$stateChangeStart', function(){ 
                $('body').addClass('load');
            })

            $rootScope.$on('$stateChangeSuccess', function(){
                $('body').removeClass('load');
            })

        };
    })

    .directive('playVideo', function() {
        return {
            restrict: 'A',
            link: function (scope, element) {
                console.log('hekd');
                element.on('click', function () {
                    $(this).children('.video-overlay').css('display', 'none');
                    $(this).children('#video')[0].play();    
                });
            }
        };
    })

    // Smooth transition between pages
    .directive('imagesLoaded', function ($window, $rootScope, $timeout) {
        return function() {
            if($rootScope.imagesLoading == false) {
              $timeout(function () {
                  var $container = $('.masonry-wrapper');
                  $('.loading-animation').hide().animate({ opacity: 1 }, 500 );
                  $container.show().animate({ opacity: 1 }, 500 );
              }, 300);
            }
        };
    })

  	.directive('scrollUp', function ($timeout, $rootScope) {
  		return {
  	    	link: function (scope, element, attrs) {
  	        	if($rootScope.loading == false) {
  		        	$timeout(function () {
  		                element.animate({
  		                    top: '0',
  		                    opacity: 1
  		                }, 10);
  			        }, 1000);
  		        };
  	    	}
  	    }
  	})


    .directive('updatelinks', function($timeout) {
        return {
            link: function(scope, element) {
                $timeout(function() {
                    element.find('a').prop('target', '_blank');
                });
            }
        };
    })


})();






















angular.module("protein").run(["$templateCache", function($templateCache) {$templateCache.put("templates/views/admin/index.html","<ui-view></ui-view>");
$templateCache.put("templates/views/entries/index.html","<md-header></md-header><main-navigation></main-navigation><md-content><div class=\"page\" ng-init=\"onPageLoad()\"><loading></loading><div class=\"fadein-slow\" ng-if=\"!loading\"><div infinite-scroll=\"addMoreItems()\" infinite-scroll-disabled=\"!ready\" infinite-scroll-distance=\"1\" ng-if=\"!unauthorized\" style=\"min-height: 1000px\"><div class=\"wrapper wrapper-lg\"><div class=\"masonry-wrapper\" images-loaded=\"\" masonry=\"\" masonry-options=\"{ itemSelector: &#39;.masonry-brick&#39;, transitionDuration: 0 }\" ng-if=\"!imagesLoading\" scroll-up=\"\"><entry-card class=\"masonry-brick entry-card\" ng-if=\"r.attributes.response_type == 2 || r.attributes.response_type == 3 || r.attributes.response_type == 7 || r.attributes.response_type == 8\" ng-repeat=\"r in responses track by $index\"></entry-card></div><empty ng-if=\"empty\"></empty><div class=\"clearfix\"></div><div class=\"spacer\"></div><loading-animation ng-if=\"loadingScroll\"></loading-animation></div></div></div></div></md-content><md-footer></md-footer>");
$templateCache.put("templates/views/entries/show.html","<md-header></md-header><main-navigation></main-navigation><md-content><div class=\"page\" id=\"response-show\"><loading></loading><div class=\"fadein-slow\" ng-if=\"!loading\"><div class=\"wrapper wrapper-md center-text\"><div id=\"response-header\"><h1 ng-bind-html=\"task.task.title\"></h1><h3><span>{{task.contact.labels.segment_list[0]}}:</span> <a class=\"underline\" ng-href=\"/a/contact/{{task.contact.id}}\">{{task.contact.first_name}} {{task.contact.last_name}}</a></h3><div ng-repeat=\"r in responses\"><h4 class=\"small\" ng-if=\"$last\">Last update: {{r.attributes.updated_at | date: &#39;d MMM yyyy&#39;}}</h4></div></div><div id=\"response-main\"><div id=\"response-main-block\" ng-repeat=\"r in responses | orderBy: &#39;attributes.updated_at&#39;\"><div ng-if=\"r.attributes.response_type == 3\"><div class=\"image-block\" ng-click=\"imageModal($event, r.attributes)\"><img class=\"click\" ng-src=\"{{r.attributes.image.original}}\"></div><div class=\"text-block\" ng-class=\"{&#39;show&#39;: hover}\"><p ng-bind-html=\"r.attributes.note\"></p></div></div><div ng-if=\"r.attributes.response_type == 7\"><blockquote class=\"click\" ng-click=\"imageModal($event, r.attributes)\"><p><span>&quot;{{r.attributes.note}}&quot;</span><br><span class=\"bold\">– {{r.attributes.contact.fullname}}, {{r.attributes.updated_at | date: &#39;LLLL yyyy&#39;}}</span></p></blockquote></div><div ng-if=\"r.attributes.response_type == 8\"><div class=\"video-block\" play-video=\"\"><video id=\"video\" ng-click=\"imageModal($event, r.attributes)\" ng-src=\"{{r.attributes.video}}\"></video><div class=\"video-overlay click\"><i class=\"material-icons white-text\">play_arrow</i></div></div><div class=\"text-block\"><p ng-bind-html=\"r.attributes.note\"></p></div></div><div ng-if=\"r.attributes.response_type == 2\"><div ng-if=\"!r.attributes.embed\"><img ng-if=\"r.attributes.extra.image\" ng-src=\"{{r.attributes.extra.image}}\" style=\"min-height: 170px\"><div class=\"text-block\"><h2 ng-if=\"r.attributes.extra.title\"><a class=\"underline\" href=\"{{r.attributes.url}}\" ng-bind-html=\"r.attributes.extra.title\" target=\"_blank\"></a></h2><p><a class=\"grey-text\" href=\"{{r.attributes.url}}\" target=\"_blank\">via {{r.attributes.extra.domain}}</a></p></div></div><div class=\"iframe\" ng-if=\"r.attributes.embed\"><iframe ng-src=\"{{r.attributes.embed}}\"></iframe></div><a class=\"underline\" href=\"{{r.attributes.url}}\" ng-if=\"r.attributes.embed\" target=\"_blank\">Watch on Youtube</a><div class=\"text-block\"><p ng-bind-html=\"r.attributes.note\"></p></div></div></div></div></div></div></div></md-content><md-footer></md-footer>");
$templateCache.put("templates/views/newsletters/index.html","<md-header></md-header><main-navigation></main-navigation><md-content><div class=\"page\" id=\"reports\"><div class=\"fadein-slow\"><div class=\"wrapper center-text\"><div id=\"reports-header\"><h1>Newsletters</h1></div><div id=\"reports-content\"><div class=\"contents\" ng-repeat=\"e in entries\"><h2><a class=\"link\" ng-href=\"/a/newsletters/{{e.id}}\"><span ng-bind-html=\"e.title\"></span><span class=\"material-icons\">call_made</span></a></h2></div></div></div></div></div></md-content><md-footer></md-footer>");
$templateCache.put("templates/views/newsletters/show.html","<md-header></md-header><main-navigation></main-navigation><md-content><div class=\"page\" id=\"reports\"><loading></loading><div class=\"fadein-slow\" ng-if=\"!loading\"><div class=\"wrapper wrapper-tiny\" id=\"report-wrapper\"><div class=\"article-header\"><h1 ng-bind-html=\"entry.title\"></h1><div class=\"date\" ng-bind-html=\"entry.updated_at | date: &#39;MMdyy&#39;\"></div></div><div class=\"article-block\" ng-repeat=\"e in entry.sections[0].sub_sections\"><div class=\"article-block-section\" ng-repeat=\"s in e.fields\"><h2 ng-bind-html=\"s.data.text\" ng-if=\"s.type == &#39;h2&#39;\"></h2><span ng-bind-html=\"s.data.text\" ng-if=\"s.type == &#39;text&#39; || s.type == &#39;list&#39;\"></span><img ng-if=\"s.type == &#39;image&#39;\" ng-src=\"{{s.data.images.medium}}\"></div><hr></div></div></div></div></md-content><md-footer></md-footer>");
$templateCache.put("templates/views/people/index.html","<md-header></md-header><main-navigation></main-navigation><md-content><div class=\"page\" id=\"people\" ng-init=\"onPageLoad()\"><loading></loading><div class=\"fadein-slow\" ng-if=\"!loading\"><div infinite-scroll=\"addMoreItems()\" infinite-scroll-disabled=\"!ready\" infinite-scroll-distance=\"1\" ng-if=\"!unauthorized\"><div class=\"wrapper wrapper-lg\"><div class=\"card image-card columns three\" ng-repeat=\"c in contacts\" scroll-up=\"\"><a ng-href=\"/a/contact/{{::c.id}}\"><div class=\"image\" style=\"background-image: url(&#39;{{::c.attributes.image.medium}}&#39;)\"></div><div class=\"text\"><h4 class=\"white-text\" ng-bind-html=\"c.attributes.labels.city_list[0] | capitalize\"></h4><h2 class=\"white-text bold\">{{::c.attributes.first_name}} {{::c.attributes.last_name}}</h2><p class=\"white-text\" ng-bind-html=\"::c.attributes.occupation\"></p></div></a></div><empty ng-if=\"empty\"></empty><div class=\"clearfix\"></div></div><div class=\"spacer\"></div><loading-animation ng-if=\"loadingScroll\"></loading-animation></div></div></div></md-content><md-footer></md-footer>");
$templateCache.put("templates/views/people/show.html","<md-header></md-header><main-navigation></main-navigation><md-content><div class=\"page\" id=\"people\"><loading></loading><div class=\"wrapper wrapper-md\" id=\"contact-show\" ng-if=\"!loading\"><div class=\"columns twelve\" id=\"contact-head\" ng-animate=\"&#39;animate&#39;\" ng-if=\"!unauthorized\"><div class=\"contact-hero columns four\" style=\"background-image: url(&#39;{{entry.data.attributes.image.original}}&#39;)\"></div><div class=\"contact-info columns eight\"><h1 class=\"bold\">{{entry.data.attributes.first_name}} {{entry.data.attributes.last_name}}</h1><h3><span ng-bind-html=\"entry.data.attributes.occupation\"></span><span ng-if=\"entry.data.attributes.occupation &amp;&amp; entry.data.attributes.labels.city_list.length\">,</span><span ng-bind-html=\"entry.data.attributes.labels.city_list[0] | capitalize\"></span></h3><ul class=\"skills\"><li class=\"bug alt-bug\" ng-repeat=\"s in entry.data.attributes.labels.segment_list track by $index\"><span ng-bind-html=\"s | capitalize | tidy\"></span></li><li class=\"bug\" ng-repeat=\"v in entry.data.attributes.labels.sector_list track by $index\"><span ng-bind-html=\"v | capitalize | space\"></span></li></ul><div class=\"clearfix\"></div><p class=\"description\" ng-bind-html=\"entry.data.attributes.description | trustEmbed\" updatelinks=\"\"></p><div id=\"contact-stats\"><div class=\"card border-card\"><div class=\"columns six no-top-margin first\"><label>Total Reach</label><h2 class=\"total-reach bold\" ng-bind-html=\"entry.data.attributes.total_reach | megaNumber\" ng-if=\"!loading\"></h2></div><div class=\"columns six no-top-margin\"><label>Engagement Rate <span class=\"material-icons logic-icon grey-text\">info_outline</span><md-tooltip>Engagement rate = (comments + shares + likes) / fans</md-tooltip></label><h2 class=\"total-reach bold\" ng-if=\"!loading\">{{entry.data.attributes.average_engagement_rate | number : 2}}%</h2></div><div class=\"clearfix\"></div><div class=\"spacer\"></div><div class=\"social_total wrapper_channel-{{p.channel | lowercase}}\" ng-if=\"p.channel_id != 0\" ng-repeat=\"p in entry.data.attributes.contact_socials | orderBy : &#39;percentage_share&#39; : &#39;reverse&#39;\"><a class=\"social-icon zmdi zmdi-{{p.channel_label | lowercase}} social-icon-{{p.channel_label | lowercase}}\" ng-href=\"{{p.channel_id | socialHandle}}/{{p.screen_name}}\" target=\"_blank\"></a><div class=\"social_chart_wrapper float-right\"><div class=\"social_chart\"><div class=\"social_chart-count indiv channel-{{p.channel_label | lowercase}}\" ng-if=\"p.percentage_share != 0\" style=\"width:{{p.percentage_share}}%;\"></div><div class=\"social_chart-count indiv channel-{{p.channel_label | lowercase}}\" ng-if=\"p.percentage_share == 0\" style=\"width:100%;\"></div></div><h3 class=\"float-left\"><a class=\"grey-text\" ng-bind-html=\"p.screen_name | handle\" ng-href=\"{{p.channel_id | socialHandle}}/{{p.screen_name}}\" target=\"_blank\"></a></h3><md-button class=\"social_chart-figure float-right\" ng-if=\"p.engagement_rate != 0\"><span ng-bind-html=\"p.engagement_rate | number: 2\"></span>%<md-tooltip>Engagement rate</md-tooltip></md-button><md-button class=\"social_chart-figure float-right\" ng-bind-html=\"p.followers | megaNumber\" ng-if=\"p.percentage_share != 0\"><md-tooltip>Followers</md-tooltip></md-button><div class=\"clearfix\"></div></div><span class=\"grey-text\" ng-if=\"p.percentage_share == null\">No stats available</span></div></div></div></div></div><div class=\"clearfix\"></div><hr><div id=\"contact-gallery\"><md-tabs id=\"contact-form-tabs\" md-dynamic-height=\"\" md-selected=\"tabIndex\"><md-tab label=\"Instagram\"><div infinite-scroll=\"addMoreImages()\" infinite-scroll-disabled=\"!imagesReady\" infinite-scroll-distance=\"1\"><loading-animation></loading-animation><div class=\"masonry-wrapper\" images-loaded=\"\" masonry=\"\" masonry-options=\"{ itemSelector: &#39;.masonry-brick&#39;, transitionDuration: 0 }\" ng-if=\"!imagesLoading\"><a class=\"masonry-brick\" masonry-brick=\"\" ng-href=\"{{instagramLink}}\" ng-repeat=\"i in images\" target=\"_blank\"><img ng-src=\"{{i.attributes.image}}\"></a><div class=\"center-text\" ng-if=\"imagesEmpty\"><p>No Instagram images available</p></div></div></div></md-tab><md-tab label=\"Yeezy Responses\"><div infinite-scroll=\"addMoreResponses()\" infinite-scroll-disabled=\"!responsesReady\" infinite-scroll-distance=\"1\"><div class=\"masonry-wrapper\" images-loaded=\"\" masonry=\"\" masonry-options=\"{ itemSelector: &#39;.masonry-brick&#39;, transitionDuration: 0 }\" ng-if=\"!imagesLoading\" scroll-up=\"\"><entry-card class=\"masonry-brick entry-card\" ng-if=\"r.attributes.response_type == 3 || r.attributes.response_type == 7 || r.attributes.response_type == 8\" ng-repeat=\"r in responses track by $index\"></entry-card><div class=\"center-text\" ng-if=\"empty\"><p>No images sent in from {{entry.data.attributes.first_name}} yet</p></div></div></div></md-tab></md-tabs></div></div></div></md-content><md-footer></md-footer>");
$templateCache.put("templates/views/shared/empty.html","<div class=\"center-text\"><p>No {{segment | capitalize}}s added yet</p></div>");
$templateCache.put("templates/views/shared/footer.html","<footer role=\"contentInfo\"><div class=\"copyright\"><a href=\"http://os.prote.in\">Protein</a> <span ng-bind-html=\"date | date: &#39;yyyy&#39;\"></span></div></footer>");
$templateCache.put("templates/views/shared/header.html","<header id=\"main-header-wrapper\" role=\"banner\"><div id=\"main-header\"><i class=\"material-icons menu-trigger coloured-text show-on-mobile\" ng-click=\"toggleLeft()\">menu</i><i class=\"material-icons menu-trigger coloured-text hide-on-mobile\">lens</i><a class=\"logo yeezy-logo\" ng-href=\"/a/moodboard\"></a><div class=\"date float-right show-on-mobile\" ng-bind-html=\"currentDate | date: &#39;MMdyy&#39;\"></div><div class=\"hide-on-mobile\" id=\"navigation\"><ul><li><a class=\"link\" href=\"/a/moodboard\" ng-class=\"{&#39;active&#39;: page == &#39;moodboard&#39;}\">Moodboard</a></li><li><a class=\"link\" href=\"/a/newsletters\" ng-class=\"{&#39;active&#39;: page == &#39;newsletters&#39;}\">Newsletters</a></li><li><a class=\"link\" href=\"/a/scout\" ng-class=\"{&#39;active&#39;: segment == &#39;scout&#39;}\">Scouts</a></li><li><a class=\"link\" href=\"/a/consumers\" ng-class=\"{&#39;active&#39;: segment == &#39;consumers&#39;}\">Consumers</a></li><li class=\"logout\"><a class=\"link material-icons\" href=\"/a/logout\">lock_outline</a></li></ul></div><div class=\"float-right hide-on-mobile\" id=\"welcome\"><ul><li><span ng-if=\"currentTime &lt;= 12\">Good Morning</span><span ng-if=\"currentTime &gt; 12 &amp;&amp; currentTime &lt;= 18\">Good Afternoon</span><pan ng-if=\"currentTime &gt; 18\">Good Evening</pan></li><li ng-bind-html=\"currentDate | date: &#39;MMdyy&#39;\"></li><li>Portland, USA</li></ul></div></div></header>");
$templateCache.put("templates/views/shared/loading-animation.html","<div class=\"loading-animation center-text\" title=\"5\"><svg height=\"30px\" id=\"Layer_1\" style=\"enable-background:new 0 0 50 50;\" version=\"1.1\" viewbox=\"0 0 24 30\" width=\"24px\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" y=\"0px\"><rect class=\"shape shape-a\" fill=\"#333\" height=\"5\" width=\"4\" x=\"0\" y=\"13\"></rect><rect class=\"shape shape-b\" fill=\"#333\" height=\"15\" width=\"4\" x=\"10\" y=\"13\"></rect><rect class=\"shape shape-c\" fill=\"#333\" height=\"5\" width=\"4\" x=\"20\" y=\"13\"></rect></svg></div>");
$templateCache.put("templates/views/shared/loading.html","<div class=\"loading\" ng-if=\"loading\"><loading-animation></loading-animation></div>");
$templateCache.put("templates/views/shared/navigation.html","<md-sidenav class=\"md-sidenav-left md-whiteframe-4dp\" id=\"main-navigation\" md-component-id=\"left\"><div class=\"main-navigation-top\"><a class=\"logo yeezy-logo\" ng-href=\"/a/moodboard\"></a></div><nav><ul><li><a class=\"link\" href=\"/a/moodboard\">Moodboards</a></li><li><a class=\"link\" href=\"/a/newsletters\">Newsletters</a></li><li><a class=\"link\" href=\"/a/scout\" ng-class=\"{&#39;active&#39;: segment == &#39;scout&#39;}\">Scouts</a></li><li><a class=\"link\" href=\"/a/consumers\" ng-class=\"{&#39;active&#39;: segment == &#39;consumers&#39;}\">Consumers</a></li><div class=\"spacer\"></div><li><a class=\"link\" href=\"/logout\"><span>Logout</span><i class=\"material-icons\">lock_outline</i></a></li></ul></nav></md-sidenav>");
$templateCache.put("templates/views/static_pages/about.html","<md-header></md-header><main-navigation></main-navigation><md-content><div class=\"page\"><div class=\"small-wrapper wrapper\"><div class=\"center\"><h3>This is the about page</h3></div></div></div></md-content><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/home.html","<md-header></md-header><main-navigation></main-navigation><md-content id=\"page\"><div class=\"wrapper-lg\"><section><div class=\"wrapper-md\"><h1>Typography</h1><hr></div><div class=\"wrapper-md\"><h1>The is a h1</h1><h2>The is a h2</h2><h3>The is a h3</h3><h4>The is a h4</h4><p>From art to politics, movements happen in an inevitable response to what comes before. As culture arrives splintered through a myriad of filters, it is difficult to attribute shifts like these to any one thing in particular. But a multitude of contributing factors have recently led early adopters to shift their time and money towards a subject of a less tangible nature: spirituality.</p></div><div class=\"wrapper-sm\"><p class=\"card\">Though applying consumer behaviour to matters of spirituality may seem like a contradiction in terms, plenty of brands, experiences and attitudes are proving otherwise. For too long we’ve been coerced into valuing convenience and technology above all else, with the persuasion that streamlining our lives is the ultimate progression of modern living. While the short term gains are evident, in the long run these self-improvements have begun to feel empty.</p></div><div class=\"wrapper-md\"><p>And the traditional markers of <span class=\"small\">identity that we once knew have been gradually eroding.</span>Gender, nationality, religion and age are shifting from rigid labels that define who we are to much more fluid, blurred concepts. As these traditional forms of identification begin to fade, consumers are searching for new modes of guidance.</p></div></section><section><div class=\"wrapper-md\"><h1>Buttons & links</h1><hr></div><div class=\"wrapper-md\"><div layout=\"row\"><div class=\"btn\">Regular button</div><button class=\"submit-btn\">Form button <span class=\"material-icons\">done</span></button><div class=\"btn border-btn\">Border button</div><div class=\"btn transparent-btn\">Transparent button</div></div><div layout=\"row\"><div class=\"btn center-btn\">Centered button</div></div><div layout=\"row\"><div class=\"btn disabled-btn\">Disabled button</div><div class=\"btn warning-btn\">Warning button <span class=\"material-icons\">warning</span></div><div class=\"btn cancel-btn\">Cancel button <span class=\"material-icons\">close</span></div><div class=\"btn\">Icon button <span class=\"material-icons\">face</span></div></div><br><a href=\"#\">This is a link</a><br><br><a class=\"coloured-link\" href=\"#\">This is a coloured link</a><br><br><a class=\"underlined-link\" href=\"#\">This is an underlined link</a></div></section><section><div class=\"wrapper-md\"><h1>Cards & grid</h1><hr></div><div class=\"container wrapper-md\"><div class=\"row\"><div class=\"three columns\"><div class=\"card article-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p></div></div></div><div class=\"three columns\"><div class=\"card article-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></div><div class=\"three columns\"><div class=\"card article-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></div><div class=\"three columns\"><div class=\"card article-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></div></div></div><div class=\"clearfix\"></div><div class=\"container wrapper-md\"><div class=\"row\"><div class=\"twelve columns\"><div class=\"card jumbo-card\"><span layout=\"row\"><div class=\"image\" flex=\"50\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text-wrapper\" flex=\"50\"><div class=\"text vert-align\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></span></div></div></div></div><div class=\"clearfix\"></div><div class=\"container wrapper-md\"><div class=\"row\"><div class=\"eight columns\"><div class=\"card jumbo-card\"><span layout=\"row\"><div class=\"image\" flex=\"50\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text-wrapper\" flex=\"50\"><div class=\"text vert-align\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></span></div></div><div class=\"four columns\"><div class=\"card article-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></div></div></div><div class=\"clearfix\"></div><div class=\"container wrapper-md\"><div class=\"row\"><div class=\"four columns\"><div class=\"card image-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></div><div class=\"four columns\"><div class=\"card image-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></div><div class=\"four columns\"><div class=\"card image-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></div></div></div><div class=\"clearfix\"></div><div class=\"container wrapper-md\"><div class=\"row\"><div class=\"six columns card list-card\"><h2>Daily Dose</h2><hr><div class=\"row list-card-row\"><div class=\"image three columns\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text nine columns\"><h3>Title of the story</h3><p>Once upon a time something happened and everyone was outraged.</p></div></div><div class=\"row list-card-row\"><div class=\"image three columns\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text nine columns\"><h3>Title of the story</h3><p>Once upon a time something happened and everyone was outraged.</p></div></div><div class=\"row list-card-row\"><div class=\"image three columns\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text nine columns\"><h3>Title of the story</h3><p>Once upon a time something happened and everyone was outraged.</p></div></div></div><div class=\"six columns\"><div class=\"card image-card\"><div class=\"image\" style=\"background-image:url(&#39;https://unsplash.it/200/300?random&#39;)\"></div><div class=\"text\"><h4 class=\"coloured-text\">Category</h4><h2>This is a card</h2><p>This card is all about jerk chicken. And how delicious it is.</p><a class=\"coloured-link\" href=\"#\">Read more</a></div></div></div></div></div><div class=\"clearfix\"></div></section></div></md-content><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/login.html","<div id=\"login-page\"><div class=\"login-form\"><a class=\"logo yeezy-logo\" ng-href=\"/a/stream\"></a><form ng-submit=\"submit()\"><label>Enter your username</label><input autofocus=\"\" class=\"field\" name=\"username\" ng-model=\"username\" placeholder=\"me@mydomain.com\" required=\"\" style=\"text-transform: lowercase\" type=\"text\"><label>Enter your password</label><input class=\"field\" name=\"pass\" ng-model=\"pass\" placeholder=\"******\" required=\"\" type=\"password\"><button class=\"submit-btn center-btn\" type=\"submit\"><span ng-bind-html=\"message\"></span><span class=\"material-icons\">keyboard_arrow_right</span></button></form><div class=\"center-text\"><h4 class=\"error\" ng-bind-html=\"fail_message\"></h4><h4 class=\"grey-text small\"><a ng-href=\"/reset\">Forgot your password?</a></h4></div></div></div><md-footer class=\"absolute\"></md-footer>");
$templateCache.put("templates/views/static_pages/reset.html","<div id=\"login-page\"><div class=\"login-form\"><a class=\"logo yeezy-logo\" ng-href=\"/a/stream\"></a><div class=\"center-text\"><h2>Reset your password</h2><p>Enter your email address and we will send you an email with reset instructions</p></div><form ng-submit=\"submit()\"><label>Enter your email</label><input autofocus=\"\" class=\"field\" name=\"username\" ng-model=\"user.email\" placeholder=\"me@mydomain.com\" required=\"\" type=\"text\"><button class=\"submit-btn center-btn\" type=\"submit\"><span ng-bind-html=\"message\"></span><span class=\"material-icons\">settings_backup_restore</span></button><div class=\"spacer\"></div></form><div class=\"center-text\"><h4 class=\"error\" ng-bind-html=\"fail_message\"></h4><h4 class=\"grey-text small\"><a ng-href=\"/login\">Go back</a></h4></div></div></div>");
$templateCache.put("templates/views/entries/shared/entry-card.html","<a class=\"task-response-main\" ng-href=\"/a/moodboard/{{r.attributes.task.id}}/{{r.attributes.contact_task.id}}\"><div class=\"response-block link-block\" ng-if=\"r.attributes.response_type == 2\"><div ng-if=\"!r.attributes.embed\"><img ng-if=\"r.attributes.extra.image\" ng-src=\"{{r.attributes.extra.image}}\" style=\"min-height: 170px\"><div class=\"link-info-block\" ng-if=\"!r.attributes.embed\"><h2 class=\"white-text\" ng-bind-html=\"r.attributes.extra.title\" ng-if=\"r.attributes.extra.title\"></h2><p class=\"grey-text\">via {{r.attributes.extra.domain}}</p></div></div><div ng-if=\"r.attributes.embed\"><iframe ng-src=\"{{r.attributes.embed}}\"></iframe></div><div class=\"response-text-block\"><h2 class=\"underline\" ng-bind-html=\"r.attributes.task.title\"></h2><i class=\"material-icons launch-icon\">call_made</i></div></div><div class=\"response-block image-block\" ng-if=\"r.attributes.response_type == 3\" style=\"max-width: {{r.attributes.extra.dimensions[0].medium.width}}px;\"><div class=\"response-text-block\"><h2 class=\"underline\" ng-bind-html=\"r.attributes.task.title\"></h2><i class=\"material-icons launch-icon\">call_made</i></div><img class=\"click\" ng-src=\"{{r.attributes.image.medium}}\" style=\"width: {{r.attributes.extra.dimensions[0].medium.width}}px; height: {{r.attributes.extra.dimensions[0].medium.height}}px\"></div><div class=\"response-block text-block\" ng-if=\"r.attributes.response_type == 7\"><blockquote><p><span>&quot;{{r.attributes.note}}&quot;</span><br><span class=\"bold\">– {{r.attributes.contact.fullname}}, {{r.attributes.updated_at | date: &#39;LLLL yyyy&#39;}}</span></p></blockquote><div class=\"response-text-block\"><h2 class=\"underline\" ng-bind-html=\"r.attributes.task.title\"></h2><i class=\"material-icons launch-icon\">call_made</i></div></div><div class=\"response-block video-block\" ng-if=\"r.attributes.response_type == 8\"><div class=\"video-block\" play-video=\"\"><video id=\"video\" ng-click=\"imageModal($event, r.attributes)\" ng-src=\"{{r.attributes.video}}\"></video><div class=\"video-overlay click\"><i class=\"material-icons white-text\">play_arrow</i></div></div><div class=\"response-text-block\"><p ng-bind-html=\"r.attributes.note\"></p></div></div></a>");
$templateCache.put("templates/views/entries/shared/entry-modal.html","<div id=\"modal-form\"><loading-animation></loading-animation><a class=\"modal-header\" href=\"a/scouts/{{s.contact.id}}\"><h3 class=\"no-margin\"><span class=\"bold\">{{s.contact.fullname}}</span> <span>•</span> <span class=\"small\">{{s.updated_at | date: &#39;d MMM yyyy&#39;}}</span></h3><p ng-bind-html=\"s.task.title\"></p></a><img ng-if=\"s.response_type == 3\" ng-src=\"{{s.image.original}}\"><a class=\"material-icons white-text download-btn\" ng-href=\"{{s.image.original}}\" ng-if=\"s.response_type == 3\" target=\"_blank\">cloud_download</a><blockquote ng-if=\"s.response_type == 7\"><p><span>&quot;{{s.note}}&quot;</span><br><span class=\"bold\">– {{s.contact.fullname}}, {{s.updated_at | date: &#39;LLLL yyyy&#39;}}</span></p></blockquote><div class=\"video\" ng-if=\"s.response_type == 8\" play-video=\"\"><video id=\"video\" ng-src=\"{{s.video}}\"></video><div class=\"video-overlay\"><i class=\"material-icons white-text\">play_arrow</i></div><a class=\"material-icons white-text download-btn\" ng-href=\"{{s.video}}\" target=\"_blank\">cloud_download</a></div><div class=\"text-block\" ng-if=\"s.response_type != 7\"><p class=\"no-margin\" ng-bind-html=\"s.note\"></p></div></div>");}]);